export default __webpack_public_path__ + "static/media/field-min.7d27f983.png";